<template>
    <el-row :gutter="30" style="margin-left: 0; margin-right: 0">
        <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="16">
            <el-form>
                <el-form-item>
                    <el-checkbox
                        @change="onChangeRepeatLastOrder"
                        v-model="form.repeat_last_month_order"
                        :disabled="inShoppingCart"
                        style="margin-top: 20px"
                    >
                        <span class="repeat-order-title"
                            >Repeat last month's order</span
                        >
                        <div class="repeat-order-description">
                            Click here to add the same items as last month
                        </div>
                    </el-checkbox>
                </el-form-item>

                <el-collapse v-model="activeTabs">
                    <el-collapse-item
                        title="Printed Newsletter Options"
                        name="1"
                    >
                        <div class="product-card__content">
                            <el-form-item
                                :class="form.state('quantity')"
                                :required="true"
                                label="Printed Newsletter Quantity"
                                v-if="requiresQuantity"
                            >
                                <el-select
                                    name="quantity"
                                    v-model.number="form.quantity"
                                    v-validate.disable="'required'"
                                    no-data-text="You must add your calendar to the shopping cart first."
                                >
                                    <el-option
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                        v-for="item in quantityOptions"
                                    />
                                </el-select>
                                <form-feedback :form="form" field="quantity" />
                            </el-form-item>
                            <el-form-item v-else>
                                Newsletter Quantity: {{ calculatedQuantity }}
                            </el-form-item>

                            <el-form-item
                                :class="form.state('color_type')"
                                :required="true"
                                v-if="requiresColorType"
                            >
                                <el-row :gutter="15">
                                    <el-col :md="12">
                                        <el-radio
                                            :label="ColorTypes.COLORED"
                                            name="color_type"
                                            v-model="form.color_type"
                                            v-validate="'required'"
                                            >Color
                                        </el-radio>
                                        <br />
                                        <a
                                            @click.prevent="
                                                form.color_type =
                                                    ColorTypes.COLORED
                                            "
                                            class="block"
                                            href="#"
                                        >
                                            <img
                                                class="w-50"
                                                src="/images/order/newsletter/color.jpg"
                                            />
                                        </a>
                                    </el-col>
                                    <el-col :md="12">
                                        <el-radio
                                            :label="ColorTypes.BLACK_AND_WHITE"
                                            name="color_type"
                                            v-model="form.color_type"
                                            v-validate="'required'"
                                            >Black
                                        </el-radio>
                                        <br />
                                        <a
                                            @click.prevent="
                                                form.color_type =
                                                    ColorTypes.BLACK_AND_WHITE
                                            "
                                            class="block"
                                            href="#"
                                        >
                                            <img
                                                class="w-50"
                                                src="/images/order/newsletter/bw.jpg"
                                            />
                                        </a>
                                    </el-col>
                                </el-row>
                                <form-feedback
                                    :form="form"
                                    custom-message="Please select an item."
                                    field="color_type"
                                />
                            </el-form-item>

                            <div class="mt-15">
                                <el-button
                                    v-if="!inShoppingCart"
                                    @click="submit()"
                                    icon="mdi mdi-cart-plus"
                                    type="primary"
                                    >Add to Cart</el-button
                                >
                                <el-button
                                    v-else
                                    @click="submit()"
                                    icon="mdi mdi-cart-plus"
                                    type="primary"
                                    >Update Cart</el-button
                                >
                            </div>
                        </div>
                    </el-collapse-item>

                    <el-collapse-item title="Digital Files" name="2">
                        <span style="font-style: italic"
                            >(viewable in the News Proofs section of the sidebar
                            menu)</span
                        >
                        <div class="product-cards flex-row">
                            <div
                                v-for="file in digitalFiles"
                                :key="file.id"
                                class="flex-col-33 flex-col-xl-25"
                            >
                                <div
                                    class="product-card"
                                    @click="toggleDigitalFile(file)"
                                    :class="{
                                        'product-card--disabled': file.disabled
                                    }"
                                >
                                    <div class="product-card__preview">
                                        <img
                                            :src="
                                                file.image ? file.image.url : ''
                                            "
                                            class="w-full"
                                            v-if="file.image"
                                            :alt="file.name"
                                        />
                                    </div>
                                    <div class="product-card__content">
                                        <div class="product-card__title">
                                            <h5>{{ file.name }}</h5>
                                            <div
                                                class="price-tag"
                                                v-if="file.price"
                                            >
                                                (${{ file.price }})
                                            </div>
                                        </div>
                                        <div class="product-card__description">
                                            {{ file.description }}
                                        </div>
                                        <el-checkbox
                                            :id="`digital-file-${file.id}`"
                                            :disabled="file.disabled"
                                            :label="file.id"
                                            v-model="form.digital_files"
                                            @change="
                                                (e) => onChangeCheck(e, file)
                                            "
                                            class="mt-10"
                                        >
                                            <span @click.stop>Select</span>
                                        </el-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Add cart button for digital files -->
                        <div class="mt-15">
                            <el-button
                                v-if="!hasDigitalFilesInCart"
                                @click="submit()"
                                icon="mdi mdi-cart-plus"
                                type="primary"
                                >Add to Cart</el-button
                            >
                            <el-button
                                v-else
                                @click="submit()"
                                icon="mdi mdi-cart-plus"
                                type="primary"
                                >Update Cart</el-button
                            >
                        </div>
                    </el-collapse-item>

                    <el-collapse-item
                        title="Custom Birthday Posters"
                        name="6"
                        v-if="
                            !$store.state.current_community.has_calendar &&
                            $store.state.current_community.has_newsletter
                        "
                    >
                        <birthday-posters
                            posters="form.birthday_posters || []"
                            :saving="birthdayPostersForm.busy"
                            :month="newsletter.month"
                            :year="newsletter.year"
                            @save="saveBirthdayPosters()"
                        />
                    </el-collapse-item>
                    <el-collapse-item
                        title="Printed Extras"
                        name="7"
                        v-if="
                            !$store.state.current_community.has_calendar &&
                            $store.state.current_community.has_newsletter
                        "
                    >
                        <div :gutter="10" class="product-cards flex-row">
                            <div
                                :key="extra.id"
                                class="flex-col-33 flex-col-xl-25"
                                v-for="extra in computedPrintedExtras"
                            >
                                <product-card
                                    v-if="extra.is_active"
                                    :loading="
                                        isItemBusy(extra, 'adding-to-cart')
                                    "
                                    :added-to-cart="
                                        isAddedToCart({
                                            printed_extra: extra,
                                            newsletter_id: newsletter.id
                                        })
                                    "
                                    :order-item-printed-extra="
                                        extra.order_item_printed_extra
                                    "
                                    :printed-extra="extra"
                                    @add-to-cart="addToCart"
                                    @change-quantity="
                                        (quantity) =>
                                            onChangePrintedExtraQuantity({
                                                quantity,
                                                order_item_printed_extra:
                                                    extra.order_item_printed_extra
                                            })
                                    "
                                    @delete="
                                        onDeletePrintedExtra({
                                            order_item_printed_extra:
                                                extra.order_item_printed_extra
                                        })
                                    "
                                />
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
        </el-col>
        <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="8" v-show="showCart">
            <cart
                :show-checkout-button="true"
                :show-product-total="true"
                :show-summary="false"
                ref="cart"
                style="max-width: 500px"
            />
        </el-col>
    </el-row>
</template>

<script>
import * as CalendarStatus from "@/constants/calendar-statuses";
import * as ColorTypes from "@/constants/color-types";
import DigitalFiles from "@/constants/digital-files";
import cart_updated_listener from "@/mixins/cart-updated-listener";
import cart_mixin from "@/mixins/cart_mixin";
import * as Actions from "@/store/constants/actions";
import * as Getters from "@/store/constants/getters";
import * as Mutations from "@/store/constants/mutations";
import Cart from "@/views/pages/calendar/single/place-order/Cart";
import _ from "lodash";
import { mapGetters, mapState } from "vuex";
import BirthdayPosters from "../../calendar/single/place-order/BirthdayPosters";
import ProductCard from "../../calendar/single/place-order/ProductCard";
//uses https.js imported in window.App

export default {
    mixins: [cart_mixin, cart_updated_listener],
    props: {
        newsletter: {
            type: Object,
            required: true
        }
    },
    components: {
        Cart,
        BirthdayPosters,
        ProductCard
    },
    data() {
        return {
            CalendarStatus,
            ColorTypes,
            activeTabs: [],
            cartForm: new Form({
                orders: []
            }),
            form: new Form({
                repeat_last_month_order: false,
                quantity: null,
                color_type: null,
                digital_files: []
            }),
            repeatOrderForm: new Form({
                newsletter_id: this.newsletter.id
            }),
            birthday_posters: [],
            birthdayPostersForm: new Form({
                newsletter_id: this.newsletter.id,
                birthday_posters: []
            }),
            showCart: true
        };
    },
    mounted() {
        this.form.setVeeErrors(this.veeErrors);
        this.$store.dispatch(Actions.FETCH_CART).then((response) => {
            //console.log(response.data.orders);
            this.cartForm.orders = _.cloneDeep(response.data.orders);
            let order_item = _.find(this.cartForm.orders, {
                newsletter_id: this.newsletter.id
            });
            this.birthday_posters = _.get(
                this.orderItem,
                "birthday_posters",
                []
            );
            if (order_item) {
                _.extend(
                    this.form,
                    _.pick(order_item, [
                        "repeat_last_month_order",
                        "quantity",
                        "color_type"
                    ]),
                    {
                        digital_files: order_item.digital_files.map(
                            (item) => item.id
                        )
                    }
                );
            }
            if (this.requiresPdfProof) {
                this.form.digital_files = [this.digitalFiles[1].id];
            }
        });
    },
    computed: {
        ...mapState(["cart", "current_community"]),
        ...mapState({
            printed_extras: (state) => state.printed_extras.data
        }),
        ...mapGetters([Getters.CALENDAR_ENABLED]),
        digitalFiles() {
            let digital_files = _.map(
                this.$store.getters[Getters.NEWSLETTER_DIGITAL_FILES],
                (file, i) => {
                    return {
                        ...file,
                        disabled:
                            this.requiresPdfProof &&
                            file.id == DigitalFiles.newsletterPdfOnly
                    };
                }
            );
            console.log("digital_files", digital_files);
            return digital_files;
        },
        requiresQuantity() {
            // console.log(
            //     "CALENDAR_ENABLED",
            //     this.$store.getters[Getters.CALENDAR_ENABLED]
            // );
            // console.log(
            //     "NEWSLETTER_REQUIRES_QUANTITY",
            //     this.$store.getters[Getters.NEWSLETTER_REQUIRES_QUANTITY]
            // );
            return this.$store.getters[Getters.NEWSLETTER_REQUIRES_QUANTITY];
        },
        requiresColorType() {
            // console.log(
            //     "requiresColorType",
            //     this.$store.getters[Getters.NEWSLETTER_REQUIRES_COLOR_TYPE]
            // );
            return this.$store.getters[Getters.NEWSLETTER_REQUIRES_COLOR_TYPE];
        },
        quantityOptions() {
            // console.log(
            //     "quantityOptions",
            //     this.$store.getters[Getters.NEWSLETTER_QUANTITY_OPTIONS]
            // );
            return this.$store.getters[Getters.NEWSLETTER_QUANTITY_OPTIONS];
        },
        inShoppingCart() {
            if (!this.cart) {
                return false;
            }
            return !!_.find(this.cart.orders, {
                newsletter_id: this.newsletter.id
            });
        },
        calculatedQuantity() {
            return this.cart.calculated_newsletter_quantity;
        },
        requiresPdfProof() {
            return _.get(
                this.current_community,
                "corporation.requires_newsletter_sign_off",
                false
            );
        },
        hasDigitalFilesInCart() {
            if (!this.cart) {
                return false;
            }

            const orderItem = _.find(this.cart.orders, {
                newsletter_id: this.newsletter.id
            });

            return !!(
                orderItem &&
                orderItem.digital_files &&
                orderItem.digital_files.length > 0
            );
        },
        orderItem() {
            return _.find(this.cartForm.orders, {
                newsletter_id: this.newsletter.id
            });
        },
        computedPrintedExtras() {
            let printed_extras_sorted = _.orderBy(
                this.printed_extras,
                ["type", "display_order"],
                "asc"
            );
            return printed_extras_sorted.map((extra) => {
                return {
                    ...extra,
                    order_item_printed_extra:
                        this.orderItem && this.orderItem.printed_extras
                            ? this.orderItem.printed_extras.find(
                                  (item) => item.id === extra.id
                              )
                            : null
                };
            });
        }
    },
    methods: {
        onCartUpdated() {
            this.cartForm.orders = _.cloneDeep(this.cart.orders);
            this.birthday_posters = _.get(
                this.orderItem,
                "birthday_posters",
                []
            );
            if (!this.inShoppingCart) {
                this.form.repeat_last_month_order = false;
            }
        },
        onChangeCheck(value, digital_file) {
            if (value || (this.requiresPdfProof && !value)) {
                this.form.digital_files = [digital_file.id];
            }
        },
        submit() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    return;
                }
                const new_item = {
                    newsletter_id: this.newsletter.id,
                    ..._.pick(this.form, ["quantity", "color_type"]),
                    digital_files: this.form.digital_files.map((id) => ({ id }))
                };
                const existing = _.find(this.cartForm.orders, {
                    newsletter_id: this.newsletter.id
                });
                if (existing) {
                    _.assign(existing, new_item);
                } else {
                    this.cartForm.orders.push(new_item);
                }
                this.submitCart()
                    .then(() => {
                        this.$notify.success({
                            message: "Newsletter successfully added to cart."
                        });
                    })
                    .catch((e) => {
                        console.log("submit", e);
                        if (!existing) {
                            window.Utils.arrayDelete(
                                this.cartForm.orders,
                                new_item
                            );
                        }
                    });
            });
        },
        submitCart() {
            return window.App.put(`/web-api/cart`, this.cartForm).then(
                (response) => {
                    this.$store.commit(Mutations.SET_CART, response.data);
                    this.cartForm.orders = _.cloneDeep(response.data.orders);
                    return response;
                }
            );
        },
        onChangeRepeatLastOrder() {
            if (this.form.repeat_last_month_order) {
                window.App.post(`/web-api/cart/repeat`, this.repeatOrderForm)
                    .then((response) => {
                        this.$store.commit(Mutations.SET_CART, response.data);
                        this.cartForm.orders = _.cloneDeep(
                            response.data.orders
                        );
                    })
                    .catch((e) => {
                        console.log("onChangeRepeatLastOrder", e);
                    });
            } else {
                this.cartForm.orders = _.reject(this.cartForm.orders, {
                    newsletter_id: this.newsletter.id
                });
                this.submitCart().catch((e) => {
                    console.log("onChangeRepeatLastOrder", e);
                });
            }
        },
        saveBirthdayPosters() {
            if (!this.inShoppingCart) {
                this.$notify.warning({
                    message: "First you need to add newsletter."
                });
                this.$parent.scrollTo({
                    el: "#newsletter-sec"
                });
            } else {
                this.birthdayPostersForm.birthday_posters = _.values(
                    _.filter(this.birthday_posters, (item) => {
                        return (
                            item.name &&
                            !_.isEmpty(item.name.trim()) &&
                            !_.isEmpty(item.birth_date)
                        );
                    })
                );
                window.App.post(
                    `/web-api/cart/birthday-posters`,
                    this.birthdayPostersForm
                )
                    .then((response) => {
                        this.$store.commit(Mutations.SET_CART, response.data);
                        this.$notify.success({
                            message: "Cart has been updated."
                        });
                    })
                    .catch((e) => {
                        console.log("saveBirthdayPosters", e);
                    });
            }
        },
        onDeletePrintedExtra({ order_item_printed_extra }) {
            this.confirmRemove().then(() => {
                window.Utils.arrayDelete(
                    this.orderItem.printed_extras,
                    order_item_printed_extra
                );
                this.submitCart()
                    .then(() => {
                        this.successItemRemoved();
                    })
                    .catch((e) => {
                        console.log("onDeletePrintedExtra", e);
                    });
            });
        },
        onChangePrintedExtraQuantity({
            order_item_printed_extra = null,
            quantity
        }) {
            //console.log('onChangePrintedExtraQuantity (newsletter)', {order_item_printed_extra, quantity});
            if (order_item_printed_extra) {
                order_item_printed_extra.quantity = quantity;
                this.submitCart()
                    .then(() => {
                        this.$notify.success({
                            message: "Quantity has been updated."
                        });
                    })
                    .catch((e) => {
                        console.log("onChangePrintedExtraQuantity", e);
                    });
            }
        },
        addToCart(payload) {
            let form = {
                newsletter_id: this.newsletter.id
            };
            let action;
            let busy_item;
            if (payload.printed_extra) {
                busy_item = payload.printed_extra;
                action = "adding-to-cart";
                form["printed_extra"] = {
                    id: payload.printed_extra.id,
                    quantity: payload.quantity
                };
            } else {
                return;
            }
            if (!this.inShoppingCart) {
                this.$notify.warning({
                    message: "First you need to add newsletter."
                });
                this.$parent.scrollTo({
                    el: "#newsletter-sec"
                });
            } else {
                this.addBusyItem(busy_item, action);
                window.App.post(`/web-api/cart`, form)
                    .then(() => {
                        payload.component.reset();
                        this.$refs.cart.refresh();
                        this.$notify.success({
                            message: "Item has been added to cart."
                        });
                    })
                    .catch((e) => {
                        console.log("addToCart", e);
                    })
                    .finally(() => {
                        this.removeBusyItem(busy_item, action);
                    });
            }
        },
        successItemRemoved() {
            this.$notify.success({
                message: "Item has been removed from cart."
            });
        },
        confirmRemove() {
            return this.$confirm(
                "Are you sure you want to remove item from shopping cart?",
                "Warning",
                {
                    confirmButtonText: "Remove",
                    confirmButtonClass: "el-button--danger",
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            ).catch(() => {
                //user cancelled
            });
        },
        toggleDigitalFile(file) {
            if (file.disabled) return;

            const isSelected = this.form.digital_files.includes(file.id);

            if (isSelected) {
                // If already selected, remove it (unless required by PDF proof)
                if (!this.requiresPdfProof) {
                    this.form.digital_files = this.form.digital_files.filter(
                        (id) => id !== file.id
                    );
                }
            } else {
                // If not selected, add it (replacing any existing selection if required by PDF proof)
                if (this.requiresPdfProof) {
                    this.form.digital_files = [file.id];
                } else {
                    this.form.digital_files.push(file.id);
                }
            }

            // Trigger the change handler to maintain existing logic
            this.onChangeCheck(!isSelected, file);
        }
    }
};
</script>

<style lang="scss" scoped>
@use "../../../../../assets/scss/_variables" as vars;

.repeat-order-title {
    font-size: 20px;
    font-weight: bold;
    color: vars.$text-color-warning !important;
}

.repeat-order-description {
    margin-top: 5px;
    color: vars.$text-color-lighter;
    font-style: italic;
}

#newsletter-sec {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 20px;

    .product-cards {
        display: flex;
        flex-wrap: wrap;
        margin: -10px;

        .flex-col-33,
        .flex-col-xl-25 {
            padding: 10px;
            width: 100%;

            @media (min-width: 576px) {
                width: 50%;
            }

            @media (min-width: 768px) {
                width: 33.333%;
            }

            @media (min-width: 1200px) {
                width: 25%;
            }
        }
    }

    .el-select {
        width: auto;
        min-width: 120px;
        max-width: 200px;
    }

    // Optional: style the el-select dropdown to match
    :deep(.el-select-dropdown) {
        min-width: 120px !important;
    }
}

.el-checkbox {
    margin-bottom: 20px; // Increased bottom margin for better spacing
    display: block; // Ensure full width

    .el-checkbox__input {
        margin-top: 4px; // Slightly increased top margin
        vertical-align: top; // Align checkbox with text top
    }

    .el-checkbox__label {
        display: inline-block;
        line-height: 1.4; // Increased line height
        padding-left: 8px; // Add some space between checkbox and label
        width: calc(100% - 30px);

        span {
            display: block;
            margin-bottom: 8px; // Increased margin between label and description
            font-weight: 500; // Make label slightly bolder
            word-break: break-word;
            color: vars.$text-color;
        }

        .description {
            font-size: 14px; // Reduced font size
            color: vars.$text-color-lighter;
            white-space: normal;
            max-width: 600px; // Limit description width
            margin-left: 2px; // Slight indent
            line-height: 1.5; // Better readability for description
            font-style: italic;
        }
    }

    // Add hover state
    &:hover {
        .el-checkbox__label span {
            color: vars.$corwin-blue-green;
        }
    }

    // Media query for mobile
    @media (max-width: 576px) {
        margin-bottom: 16px;

        .el-checkbox__label {
            .description {
                max-width: 100%; // Full width on mobile
            }
        }
    }
}

.product-card {
    cursor: pointer;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    overflow: hidden;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%; /* Make cards fill full height of their container */

    &:hover {
        box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);

        .product-card__title h5 {
            color: vars.$corwin-blue-green;
        }
    }

    &--disabled {
        opacity: 0.7;
        cursor: not-allowed;

        &:hover {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

            .product-card__title h5 {
                color: vars.$text-color;
            }
        }
    }

    &__preview {
        overflow: hidden;
        position: relative;

        img {
            display: block;
            transition: transform 0.3s ease;
        }

        &:hover img {
            transform: scale(1.05);
        }
    }

    &__content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        flex-grow: 1; /* Allow content to take remaining space */
    }

    &__title {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 12px;

        h5 {
            font-size: 18px;
            font-weight: 500;
            margin: 0;
            color: vars.$text-color;
        }

        .price-tag {
            color: vars.$text-color;
            font-weight: 500;
        }
    }

    &__description {
        color: vars.$text-color-lighter;
        font-size: 14px;
        margin-bottom: 12px;
        font-style: italic;
        flex-grow: 1; /* Allow description to expand and push checkbox to bottom */
        min-height: 60px; /* Set a minimum height for descriptions */
        overflow-y: auto; /* Add scrolling if text is very long */
    }

    &__clickable-area {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        height: 100%;
        
        &:hover {
            .product-card__title h5 {
                color: vars.$corwin-blue-green;
            }
        }
    }
}

/* Make all card containers equal height */
.product-cards .flex-col-33,
.product-cards .flex-col-xl-25 {
    display: flex;
    flex-direction: column;
}

/* Specific styles for newsletter-sec */
#newsletter-sec.product-card {
    border-bottom: none;

    .el-form-item {
        margin-bottom: 20px;
    }

    .el-select {
        width: auto;
        min-width: 120px;
        max-width: 200px;
    }
}

/* Update birthday posters container to work within product card */
.birthday-posters-container {
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 24px;
    align-items: start;

    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
}

/* Additional styles for digital files cards */
.product-cards {
    display: flex;
    flex-wrap: wrap;
    margin: -10px;

    .flex-col-33,
    .flex-col-xl-25 {
        padding: 10px;
        width: 100%;

        @media (min-width: 576px) {
            width: 50%;
        }

        @media (min-width: 768px) {
            width: 33.333%;
        }

        @media (min-width: 1200px) {
            width: 25%;
        }
    }
}

/* Improved collapse item styling */
:deep(.el-collapse-item) {
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  
  .el-collapse-item__header {
    background-color: #f5f7fa;
    font-weight: 600;
    font-size: 18px;
    color: vars.$corwin-blue-green;
    height: 55px;
    line-height: 55px;
    padding: 0 20px;
    border-left: 4px solid vars.$corwin-blue-green;
    display: flex;
    align-items: center;
    
    &:hover {
      background-color: #eef1f6;
    }
    
    &.is-active {
      background-color: vars.$corwin-blue-green;
      color: white;
      border-bottom-color: transparent;
    }
    
    .el-collapse-item__arrow {
      margin-right: 15px;
      margin-left: auto;
      font-size: 16px;
      color: inherit;
    }
  }
  
  .el-collapse-item__content {
    padding: 20px;
    background-color: white;
  }
}
</style>
